// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 716) return "canvas.b25101e27325d95dacca.css";
	if (chunkId === 612) return "pptAddinEditor.67d29d1a906135ad9e5a.css";
	// return url for filenames based on template
	return undefined;
};